export const SAME_ORIGIN_API_BASE = '/api';

const normalizeHost = hostname => String(hostname || '')
  .trim()
  .toLowerCase()
  .replace(/^\[|\]$/g, '');

const privateIpv4 = hostname => {
  const parts = hostname.split('.').map(Number);
  if (parts.length !== 4 || parts.some(part => !Number.isInteger(part) || part < 0 || part > 255)) {
    return false;
  }

  const [first, second] = parts;
  return first === 0
    || first === 10
    || first === 127
    || (first === 169 && second === 254)
    || (first === 172 && second >= 16 && second <= 31)
    || (first === 192 && second === 168);
};

export const isLocalNetworkHost = hostname => {
  const host = normalizeHost(hostname);
  return host === 'localhost'
    || host.endsWith('.localhost')
    || host === '::1'
    || /^f[cd][0-9a-f:]+$/i.test(host)
    || /^fe[89ab][0-9a-f:]+$/i.test(host)
    || privateIpv4(host);
};

export const resolveApiBase = (configuredValue, runtimeOrigin) => {
  const configured = String(configuredValue || '').trim();
  if (!configured) return SAME_ORIGIN_API_BASE;

  try {
    const runtimeUrl = new URL(runtimeOrigin);
    const resolvedUrl = new URL(configured, runtimeUrl);
    const supportedProtocol = resolvedUrl.protocol === 'http:' || resolvedUrl.protocol === 'https:';

    // A public site must never make API calls to a visitor's computer or LAN.
    if (!supportedProtocol
      || (!isLocalNetworkHost(runtimeUrl.hostname) && isLocalNetworkHost(resolvedUrl.hostname))) {
      return SAME_ORIGIN_API_BASE;
    }

    if (/^https?:\/\//i.test(configured)) {
      return resolvedUrl.href.replace(/\/+$/, '');
    }

    const relativePath = resolvedUrl.pathname.replace(/\/+$/, '');
    return relativePath || SAME_ORIGIN_API_BASE;
  } catch {
    return SAME_ORIGIN_API_BASE;
  }
};

export const resolveApiOrigin = (apiBase, runtimeOrigin) => {
  try {
    return new URL(apiBase, runtimeOrigin).origin;
  } catch {
    return new URL(runtimeOrigin).origin;
  }
};
